import React, { useContext } from 'react';
import Paper from '@material-ui/core/Paper';
import RichTextEditor, { EditorValue } from 'react-rte';
import { Grid } from '@material-ui/core';

import { GlobalContext } from '../../../../../store';

import { ImagePicker } from '../../../../../components/ImagePicker/ImagePicker';
import Tooltip from '../../../../../components/Tooltip';
import { RTE_TOOLBARCONFIG } from '../../../Settings/ClubSettings/Utils/RTE_TOOLBARCONFIG';

interface IProps2 {
  eventId: string;
  text: EditorValue;
  setValue: any;
  setText: React.Dispatch<React.SetStateAction<EditorValue>>;
}

export const EventInformationSection = (props: IProps2) => {
  const { eventId, setText, text, setValue } = props;

  const { adminEvents } = useContext(GlobalContext);

  const event = adminEvents[Number(eventId)];

  return (
    <Paper elevation={1} className="paper paper-full event-info-setup">
      <div className="title__container override">
        <h3 className="title-tooltip override">EVENT INFORMATION</h3>
        <Tooltip
          classes={{ fab: 'tooltip-fab--shift-top-2dot5' }}
          sectionKey="EVENT_SETUP.EVENT_INFORMATION"
        />
      </div>
      <div className="admin-form-field-splitted">
        <div className="label event-info-setup__help-text">
          This information will be displayed in the event invitation so players can see all the
          details about the event - things like if cart fees and range balls are included, contests,
          prizes, and if there's a reception. Pricing comes later so don't worry about that here.
        </div>

        <Grid container={true} spacing={8}>
          <Grid
            className="general-round-info-section inner-grid-item override"
            item={true}
            xs={12}
            md={6}
          >
            <h4 className="event-info-setup__subtitle">EVENT INVITATION INFO</h4>
            <RichTextEditor
              className="rte-editor"
              value={text}
              onChange={newText => {
                setValue('description')(newText.toString('markdown'));
                setText(newText);
              }}
              toolbarConfig={RTE_TOOLBARCONFIG}
            />
          </Grid>
          <Grid
            className="general-round-info-section inner-grid-item override"
            item={true}
            xs={12}
            md={6}
          >
            <h4 className="event-info-setup__subtitle">ADD A PICTURE OF THIS EVENT</h4>
            <ImagePicker
              label="ADD A PICTURE TO THIS EVENT"
              helpText="An image from your mobile phone should work perfectly"
              addPic={setValue('image')}
              image={event.image ? event.image : undefined}
            />
          </Grid>
        </Grid>
      </div>
    </Paper>
  );
};
